<label class="mbp-radio" [class.disabled]="isDisabled()">
  <input type="radio" class="mbp-radio-input" [checked]="selected()" [disabled]="isDisabled()" (change)="onSelect()" />
  <span class="mbp-radio-control" aria-hidden="true"></span>
  @if (label()) {
    <span class="mbp-radio-label">{{ label() }}</span>
  }
  <ng-content></ng-content>
</label>
